// @flow

import { ChannelService } from './ChannelService'

export const ShopService = ChannelService
